import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { OfferBlock } from './PurchaseSection';
export function FinalPurchaseSection() {
  return <section className="py-10 md:py-14 px-4 bg-zinc-950 border-t-2 border-brand-green" data-id="element-71">
      <div className="max-w-5xl mx-auto" data-id="element-72">
        <div className="text-center mb-8" data-id="element-73">
          <div className="inline-block bg-brand-red text-white font-display font-bold px-3.5 py-1 rounded-full mb-3 uppercase tracking-wider text-[11px] md:text-xs shadow-md animate-pulse" data-id="element-74">
            ⏰ Última oportunidad — el precio cierra en:
          </div>

          <div className="mb-5" data-id="element-75">
            <CountdownTimer data-id="element-76" />
          </div>

          <h2 className="text-2xl md:text-4xl font-display font-bold text-white uppercase leading-tight" data-id="element-77">
            Elegí tu plan y <span className="highlight-green" data-id="element-78">empezá hoy</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto pt-3" data-id="element-79">
          <OfferBlock variant="base" data-id="element-80" />
          <OfferBlock variant="premium" data-id="element-81" />
        </div>
      </div>
    </section>;
}